var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "ui-shell"
    }
  }, [_vm.isThemeConfigLoading ? _c('w-r-loader') : [_vm.inAuthRoute ? [_c('r-layout-dashboard', {
    attrs: {
      "menu-options": {
        isCompact: false,
        items: _vm.menu,
        isIconChild: false,
        countLine: 2
      },
      "is-compact": "",
      "title": _vm.title,
      "sub-title": _vm.subTitle
    },
    scopedSlots: _vm._u([{
      key: "navigation",
      fn: function () {
        return [!_vm.isMicroFrontsLoading && _vm.isWidest ? [_c('breadcrumbs')] : _vm._e()];
      },
      proxy: true
    }, {
      key: "content",
      fn: function () {
        return [_vm.isMicroFrontsLoading ? [_c('w-r-loader', {
          attrs: {
            "message": _vm.loadedServicesCount
          }
        })] : _vm._e(), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.isMicroFrontsLoading,
            expression: "!isMicroFrontsLoading"
          }]
        }, [!_vm.isMicroFrontsLoading ? _c('router-view') : _vm._e(), _c('div', {
          attrs: {
            "id": "modules-container"
          }
        })], 1), _c('notify-panel', {
          attrs: {
            "moduleList": _vm.moduleList,
            "notifyMessages": _vm.messages,
            "notificationModalInterval": _vm.notificationModalInterval
          },
          on: {
            "close": function ($event) {
              return _vm.closeNotifications();
            },
            "onReadMessage": _vm.onReadMessage
          },
          model: {
            value: _vm.isNotifyPanelShow,
            callback: function ($$v) {
              _vm.isNotifyPanelShow = $$v;
            },
            expression: "isNotifyPanelShow"
          }
        }), _c('layout-observer')];
      },
      proxy: true
    }, {
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_vm.rawLogo || _vm.logoPath ? _c('div', {
          staticClass: "logo-template-image"
        }, [_c('img', {
          attrs: {
            "src": _vm.rawLogo ? "/img/raw-logo.svg" : _vm.logoPath
          }
        })]) : _vm._e(), _vm.lteWide ? [_c('r-button-simple', {
          class: _vm.isWidest ? 'mr-3' : 'mr-2',
          attrs: {
            "icon": "update",
            "type": "transparent",
            "color": "harakiri",
            "size": "spelino"
          },
          on: {
            "click": function ($event) {
              return _vm.toggleTheme();
            }
          }
        }), _c('NotificationHandler', {
          attrs: {
            "unreadMessagesCount": _vm.unreadMessagesCount,
            "isNotifyPanelShow": _vm.isNotifyPanelShow
          },
          on: {
            "toggleNotifications": function ($event) {
              return _vm.toggleNotifications();
            }
          }
        })] : _vm._e()], 2)];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_c('div', {
          staticClass: "logo-template-image",
          class: {
            collapsed: _vm.isMenuCompact
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.footerLogoPath
          }
        }), _c('div', [_c('a', {
          staticClass: "zamorano rocky--text",
          attrs: {
            "href": "https://rso.rosatom.city/",
            "target": "_blank"
          }
        }, [_vm._v(" Информация на сайте продукта ")])])])];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function () {
        return [_c('header-actions', {
          attrs: {
            "unreadMessagesCount": _vm.unreadMessagesCount,
            "isNotifyPanelShow": _vm.isNotifyPanelShow
          },
          on: {
            "toggleNotifications": function ($event) {
              return _vm.toggleNotifications();
            }
          }
        })];
      },
      proxy: true
    }], null, false, 2420473391)
  })] : _c('router-view')], _c('r-modal'), _c('r-notification', {
    staticClass: "mt-16"
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }